export const iconFontAwesomeLogisticsJetFighterUp = (
	<i className="fa-solid fa-jet-fighter-up"></i>
);
